<table class="table table-hover table-striped document-listing-container" [ngClass]="{'table-bordered': isLegalHubPlaybooksList, class: true}">
    <thead>
    <tr>
        @if (this.selectable){
            <th (click)="onSelectAllChange()">
                <input
                        type="checkbox"
                        [checked]="isAllSelected"
                        class="custom-control-input selection"/>
                <label class="custom-control-label"></label>
            </th>
        }

        @for (column of columns; track column.field) {
                <th [ngClass]='column.headerCssClass'>
                    <app-tooltip-on-text-overflow [tooltipContent]="column?.title?.trim()">{{ column.title }}</app-tooltip-on-text-overflow>
                </th>
        }
    </tr>
    </thead>
    <tbody>
        @for (dataItem of data; track dataItem.id; let index = $index) {
            <tr #cellRef class="tableDataRow">
                @if (this.selectable) {
                    <td (click)="onSelectionChange(dataItem)">
                        <input
                                type="checkbox"
                                [checked]="isSelected(dataItem)"
                                class="custom-control-input selection"/>
                        <label class="custom-control-label"></label>
                    </td>
                }

                @for (column of columns; track column.field) {
                    <td [ngClass]="column.cellCssClass" (click)="onRowClick(dataItem)">
                        <ng-template [appTableCellContent]="[dataItem, column, cellRef]"></ng-template>
                    </td>
                }
            </tr>
            @if (rowDetailsTemplate){
                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {rowData: dataItem, index: index, columns: columns}"></ng-container>
            }
        } @empty {
            <tr class="no-record">
                @if (emptyDataTemplate) {
                    <td [attr.colspan]="columns?.length || 1">
                        <ng-container *ngTemplateOutlet="emptyDataTemplate">
                        </ng-container>
                    </td>
                } @else {
                    <td [attr.colspan]="columns?.length || 1">
                        No results
                    </td>
                }
            </tr>
        }

    </tbody>
</table>